import fetch from "auth/FetchInterceptor"

const AuthService = {}

AuthService.login = function (data) {
  return fetch({
    data: data,
    method: "post",
    url: "/admin/login",
  })
}

AuthService.register = function (data) {
  return fetch({
    data: data,
    method: "post",
    url: "/auth/register",
  })
}

AuthService.logout = function () {
  return fetch({
    method: "post",
    url: "/auth/logout",
  })
}

AuthService.loginInOAuth = function () {
  return fetch({
    method: "post",
    url: "/auth/loginInOAuth",
  })
}

export default AuthService
